// ============================================================================
// DEMO BUSINESS FLAG (W-DEMO, DEMO-SPEC section 2.1)
// ----------------------------------------------------------------------------
// tenants.is_demo (migration 121) is fixed when a business is created, so the
// browser can hold it for the whole signed-in session. GET /api/auth/me
// returns it as `tenantIsDemo`, and the boot check
// (hooks/use-tenant-session-verification.ts) stores it here before any
// application surface mounts.
//
// Shared code that must behave differently for a demo business reads
// isDemoBusiness(). It is false until the server says otherwise, so RJ Bird
// Building (and every other real business) keeps its output byte for byte.
//
// ALLOWED TEST RECIPIENTS (migration 126). A demo business may also open
// email drafts to the real addresses the QuoteMaker operator put on its list
// (tenants.demo_allowed_recipients). /api/auth/me returns the list as
// `tenantDemoAllowedRecipients` (empty for every business that is not a demo)
// and the boot check stores it here next to the flag. Unlike the flag the list
// can change; a signed-in tab sees a change after it reloads.
// ============================================================================

let demoBusiness = false;
let demoAllowedRecipients: readonly string[] = Object.freeze([]);

/** True only when the signed-in business is a demo business. */
export function isDemoBusiness(): boolean {
    return demoBusiness;
}

/** Records the server's answer. Anything but a literal true reads as false. */
export function setDemoBusiness(value: unknown): void {
    demoBusiness = value === true;
}

/** The real addresses this demo business may open email drafts to, trimmed and lower-case. */
export function getDemoAllowedRecipients(): readonly string[] {
    return demoAllowedRecipients;
}

/**
 * Records the server's list. Anything but a list reads as an empty list;
 * entries that are not text, or are blank, are dropped.
 */
export function setDemoAllowedRecipients(value: unknown): void {
    const list = Array.isArray(value) ? value : [];
    demoAllowedRecipients = Object.freeze(
        list
            .filter((entry): entry is string => typeof entry === 'string')
            .map((entry) => entry.trim().toLowerCase())
            .filter(Boolean),
    );
}
